export const rescale = (
  width: number,
  height: number,
  maxWidth: number,
  maxHeight: number
) => {
  const widthRatio = maxWidth / width;
  const heightRatio = maxHeight / height;
  const scale = Math.min(widthRatio, heightRatio, 1);

  return {
    width: Math.round(width * scale),
    height: Math.round(height * scale)
  };
};
